import { type FC, useEffect, useState } from 'react';
import { fetchAvailabilityRelations } from 'slices/availabilityRelation.slice';
import { fetchMemberships } from 'slices/memberships.slice';
import { selectObjectTypesMap } from 'slices/objectTypes.slice';
import { fetchRelationTypes } from 'slices/relationType.slice';
import { fetchReservationTemplates } from 'slices/reservationTemplate.slice';
import { useAppDispatch, useAppSelector } from 'slices/store';
import { TObjectExportJob } from 'types/objectJob.type';
import { TType } from '@timeedit/types';
import { Button } from '@timeedit/ui-components';
import ObjectManagerExportModal from '../../../export/ObjectManagerExportModal';
import ExportJobExecutionResult from './ExportJobExecutionResult';
import JobDetailHeader from './JobDetailHeader';
import OperationInfo from './OperationInfo';

type Props = {
  data: TObjectExportJob;
};

const ExportDetails: FC<Props> = ({ data }: Props) => {
  const dispatch = useAppDispatch();
  const objectTypesMap = useAppSelector(selectObjectTypesMap);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchMemberships());
    dispatch(fetchRelationTypes());
    dispatch(fetchAvailabilityRelations());
    dispatch(fetchReservationTemplates());
  }, []);

  const objectType: TType | null = objectTypesMap[data.objectTypeId] ?? null;
  const canRerun = ['FINISHED', 'FAILED'].includes(data.status);

  return (
    <>
      <JobDetailHeader
        job={data}
        newOperationButton={
          <Button disabled={!canRerun} onClick={() => setModalOpen(true)}>
            Rerun job
          </Button>
        }
      />
      <OperationInfo job={data} />
      <ExportJobExecutionResult job={data} />
      <ObjectManagerExportModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        selectedObjectsCount={data.objectsToProcess.length}
        objectType={objectType}
        jobObjectSelection={{ jobId: data._id }}
        jobToReuse={data}
        redirectOnSuccess
      />
    </>
  );
};

export default ExportDetails;
